// client/src/routes/app/tenants/$tenantId/repairs.tsx — SCR-TEN-002 tab „Reparații" · D-2865.

import { createFileRoute } from '@tanstack/react-router';

import { RepairsTab } from '@/features/tenants/RepairsTab';

export const Route = createFileRoute('/app/tenants/$tenantId/repairs')({
  component: RepairsTabScreen,
});

function RepairsTabScreen() {
  const { tenantId } = Route.useParams();
  return <RepairsTab tenantId={tenantId} />;
}
